import contractTypeEditComponent from './contract_type.edit.component';

let contractTypeEditModule = angular.module('contractTypeEdit', [])

    .component('contractTypeEdit', contractTypeEditComponent)

    .name;

export default contractTypeEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/edit/index.js